export default __webpack_public_path__ + "static/media/Pay-per-click-1.c44bc19b.png";